var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.234 19.5669C35.2173 16.2336 32.684 13.8336 29.5007 13.1169C28.5673 8.95025 26.0007 5.96692 22.3673 4.83358C18.4007 3.61692 13.8007 4.80025 10.9173 7.81692C8.36732 10.4669 7.53398 14.1169 8.51732 18.0003C4.96732 18.8669 3.33398 21.9669 3.33398 24.7669C3.33398 27.9003 5.38398 31.4169 9.95065 31.7336H14.1673V27.3503C14.1673 25.2336 15.434 23.9669 17.5507 23.9669H22.4507C24.5673 23.9669 25.834 25.2336 25.834 27.3503V31.7336H27.184C27.2006 31.7336 27.234 31.7336 27.2507 31.7336C29.6173 31.7336 31.884 30.8503 33.6173 29.2669C36.334 26.9003 37.334 23.1836 36.234 19.5669Z",
    fill: "#4D4DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4493 23.9824H17.5493C15.4327 23.9824 14.166 25.2491 14.166 27.3658V32.2658C14.166 34.3824 15.4327 35.6491 17.5493 35.6491H22.4493C24.566 35.6491 25.8327 34.3824 25.8327 32.2658V27.3658C25.8327 25.2491 24.566 23.9824 22.4493 23.9824ZM22.7827 30.0824L19.9993 33.2491L19.666 33.6324C19.216 34.1491 18.8327 34.0158 18.8327 33.3158V30.3491H17.566C16.9827 30.3491 16.8327 29.9991 17.216 29.5658L19.9993 26.3991L20.3327 26.0158C20.7827 25.4991 21.166 25.6324 21.166 26.3324V29.2991H22.4327C23.016 29.2824 23.166 29.6491 22.7827 30.0824Z",
    fill: "#4D4DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudLightning);
export default __webpack_public_path__ + "static/media/cloud-lightning.8322938d7719b572f092d6930b837606.svg";
export { ForwardRef as ReactComponent };